import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";

import {
  Buttons,
  Spacer,
  boxContainer,
  questionnaireComponents,
  inputFields,
} from "..";

import "./styles.css";

const Financial = ({ setPage }) => {
  const questionnaire = useSelector(
    (state) => state?.students?.student?.profileBuilder
  );

  const [state, setState] = useState({
    knowBudgetRange: null,
    budgetRange: null,
    budgetImportance: null,
    scholarshipImportance: null,
    scholarshipImportancePerc: null,
  });

  useEffect(() => {
    setState({
      knowBudgetRange: questionnaire?.knowBudgetRange ?? null,
      budgetRange: questionnaire?.budgetRange ?? null,
      budgetImportance: questionnaire?.budgetImportance ?? null,
      scholarshipImportance: questionnaire?.scholarshipImportance ?? null,
      scholarshipImportancePerc:
        questionnaire?.scholarshipImportancePerc ?? null,
    });
  }, [questionnaire]);

  return (
    <boxContainer.LiteBoxContainer>
      <questionnaireComponents.QuestionnaireLabel
        text="1. Do you know what your ideal annual budget range for tution fee is?"
        required
      />
      <Spacer height="0.625em" />
      <div className="pl-3">
        <inputFields.HorizontalRadio
          value={state.knowBudgetRange}
          items={[
            { label: "Yes", value: "yes" },
            { label: "No", value: "no" },
          ]}
        />
      </div>
      <Spacer height="1.5em" />

      <questionnaireComponents.QuestionnaireLabel text="2. What is your ideal annual budget range for university tution fee?" />
      <Spacer height="0.3125em" />
      <div className="w-[31.25em]">
        <questionnaireComponents.QuestionnaireValueBox
          value={`${state?.budgetRange} $`}
        />
      </div>
      <Spacer height="1.5em" />
      <questionnaireComponents.QuestionnaireLabel
        text="3. How important is it for the university fees to be within your
          budget?"
        required
      />
      <Spacer height="0.625em" />
      <questionnaireComponents.QuestionnaireCircleInput
        value={state?.budgetImportance}
      />
      <Spacer height="1.5em" />
      <questionnaireComponents.QuestionnaireLabel
        text="4. How important are university scholarships for you?"
        required
      />
      <Spacer height="0.625em" />
      <questionnaireComponents.QuestionnaireCircleInput
        value={state?.scholarshipImportance}
      />
      <Spacer height="1.5em" />
      <questionnaireComponents.QuestionnaireLabel text="5. What is the minimum percentage of scholarship that you prefer?" />
      <Spacer height="0.625em" />
      <div className="pl-3 w-[31.25em]">
        <questionnaireComponents.QuestionnaireValueBox
          value={`${state?.scholarshipImportancePerc}%`}
        />
      </div>
      <Spacer height={20} />
      <div className="flex justify-end">
        <div className="w-[12.5em]">
          <Buttons.DefaultButton
            size="large"
            width="full"
            onClick={() => setPage("People")}
          >
            Next
          </Buttons.DefaultButton>
        </div>
      </div>
    </boxContainer.LiteBoxContainer>
  );
};

export default Financial;
